<script setup>
const props = defineProps({
  _siteUrl: {
    type: String,
    required: true
  },
  checked: {
    type: Boolean,
    required: true
  },
  isSetting: {
    type: Boolean,
    required: true
  },
  tagId: {
    type: Number,
    required: true
  },
  categoryName: {
    type: String,
    required: true
  },
  tagName: {
    type: String,
    required: true
  }
});

const emits = defineEmits(['change-check']);

/**
 * チェックの変更を親へ伝播
 * @param event
 */
const changeCheck = event => {
  //不正な DOM を弾く
  if (
      ! (event.target instanceof HTMLInputElement) ||
      event.target.type !== 'checkbox'
  ) {
    return;
  }

  //emit
  emits('change-check', {
    check: event.target.checked,
    tagId: props.tagId
  });
};
</script>

<template>
  <li>
    <label class="pRcLabel">
      <input
          :checked="checked"
          type="checkbox"
          name="cpTag"
          @change="changeCheck"
      >
      <div
          :style="isSetting ? 'background-color:#DDEECF' : 'background-color:#efefef'"
          class="pageCmpgnTagWrap"
      >
        <span class="pRcBtn mdCheck"></span>
        <p class="pageTagBtn">{{categoryName}}<span class="dTag">{{tagName}}</span></p>
      </div>
    </label>
  </li>
</template>
